var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.364 4.218 7.088 9.184 7.06 9.16 6 10.158l.028.024-.028.026 1.06.998.028-.026 5.276 4.967 1.06-.998-5.275-4.967 5.276-4.965-1.061-.999Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgRight;